<template>
  <div class="accordion col-12 px-0 mx-0">
    <Colapsable
      v-if="institucion.serviciosEstudiantiles"
      tituloColapsable="Servicios Estudiantiles"
      identificadorColapsable="accordion-servicios"
      identificadorAcordion="detalles"
      classCardBody="px-3 "
    >
      <div id="accordionServEs">
        <SubColapsable
          tituloColapsable="Becas y Beneficios"
          identificadorColapsable="accordion-becas"
          identificadorAcordion="servicios"
          classCardBody="columnas "
        >
          <p v-html="textoDetalleInstitucion(institucion.serviciosEstudiantiles.becasBeneficios)"></p>
          <!--{{institucion.serviciosEstudiantiles.becasBeneficios ? institucion.serviciosEstudiantiles.becasBeneficios : "Información no disponible"}}-->
        </SubColapsable>
        <SubColapsable
          tituloColapsable="Bienestar Estudiantil"
          identificadorColapsable="accordion-bienestar"
          identificadorAcordion="servicios"
          classCardBody="columnas "
        >
          <p
            v-html="textoDetalleInstitucion(institucion.serviciosEstudiantiles.bienestarEstudiantil)"
          ></p>
          <!--{{institucion.serviciosEstudiantiles.bienestarEstudiantil ? institucion.serviciosEstudiantiles.bienestarEstudiantil : "Información no disponible"}}-->
        </SubColapsable>
        <SubColapsable
          tituloColapsable="Intercambio Estudiantil"
          identificadorColapsable="accordion-intercambio"
          identificadorAcordion="servicios"
          classCardBody="columnas "
        >
          <p
            v-html="textoDetalleInstitucion(institucion.serviciosEstudiantiles.intercambioEstudiantil)"
          ></p>
          <!--{{institucion.serviciosEstudiantiles.intercambioEstudiantil ? institucion.serviciosEstudiantiles.intercambioEstudiantil : "Información no disponible"}}-->
        </SubColapsable>
        <SubColapsable
          :tituloColapsable="tipoInstituto === 'TECNICO_PROFESIONAL' ? 'Vida de Campus' : 'Vida Universitaria'"
          identificadorColapsable="accordion-vida"
          identificadorAcordion="servicios"
          classCardBody="columnas "
        >
          <p v-html="textoDetalleInstitucion(institucion.serviciosEstudiantiles.vidaDeCampus)"></p>
          <!--{{institucion.serviciosEstudiantiles.vidaDeCampus ? institucion.serviciosEstudiantiles.vidaDeCampus : "Información no disponible"}}-->
        </SubColapsable>
        <SubColapsable
          tituloColapsable="Cultura, Deporte y Extensión"
          identificadorColapsable="accordion-cultura"
          identificadorAcordion="servicios"
          classCardBody="columnas "
        >
          <p
            v-html="textoDetalleInstitucion(institucion.serviciosEstudiantiles.culturaDeporteExtension)"
          ></p>
          <!--{{institucion.serviciosEstudiantiles.culturaDeporteExtension ? institucion.serviciosEstudiantiles.culturaDeporteExtension : "Información no disponible"}}-->
        </SubColapsable>
        <SubColapsable
          tituloColapsable="Vinculación con el Medio"
          identificadorColapsable="accordion-vinculacion"
          identificadorAcordion="servicios"
          classCardBody="columnas "
        >
          <p
            v-html="textoDetalleInstitucion(institucion.serviciosEstudiantiles.vinculacionConElMedio)"
          ></p>
          <!--{{institucion.serviciosEstudiantiles.vinculacionConElMedio ? institucion.serviciosEstudiantiles.vinculacionConElMedio : "Información no disponible"}}-->
        </SubColapsable>
      </div>
    </Colapsable>
    <!--<Colapsable
      tituloColapsable="Indicadores de Calidad Académica"
      identificadorColapsable="accordion-indicadores"
      identificadorAcordion="detalles"
      classCardBody="px-0 px-md-4"
    >
      <Indicadores
        v-if="institucion.indicadoresCalidadAcademica"
        :indicadores="institucion.indicadoresCalidadAcademica"
        :tipoFicha="tipoInstituto"
      />
    </Colapsable>-->

    <Colapsable
      tituloColapsable="Infraestructura y Equipamiento"
      identificadorColapsable="accordion-infraestructura"
      identificadorAcordion="detalles"
      classCardBody="row px-4 d-md-flex"
    >
      <div class="col-md-6 mx-0 px-0">
        <img src="@/assets/img/infraestructura.jpg" text="imagen" class="img-fluid border" />
      </div>
      <Infraestructura
        v-if="institucion.infraestructurasEquipamientos"
        :info="institucion.infraestructurasEquipamientos"
      />
    </Colapsable>

    <!--<Colapsable
      tituloColapsable="Información Financiera"
      identificadorColapsable="accordion-financira"
      identificadorAcordion="detalles"
      classCardBody="px-0 px-md-4"
    >
      <InformacionFinanciera
        v-if="institucion.informacionFinanciera"
        :info="institucion.informacionFinanciera"
      />
    </Colapsable>-->
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import InformacionFinanciera from "@/components/fichaInstitucion/InformacionFinanciera";
import Colapsable from "@/components/generales/paginas/Colapsable";
import Indicadores from "@/components/generales/IndicadoresCalidad";
import Infraestructura from "@/components/fichaInstitucion/Infraestructura";
import SubColapsable from "@/components/generales/paginas/SubColapsable";
import MixinFormatearTexto from "@/mixins/FormatearTextoURL.js";
library.add(faPlus, faMinus);
export default {
  name: "DetallesInstitucion",
  props: {
    institucion: { type: Object },
    tipoInstituto: { type: String },
  },
  mixins: [MixinFormatearTexto],
  components: {
    FontAwesomeIcon,
    InformacionFinanciera,
    Colapsable,
    Indicadores,
    Infraestructura,
    SubColapsable,
  },
  methods: {
    textoDetalleInstitucion(text) {
      let texto = "";
      if (text) {
        texto = this.formatearTexto(text);
      } else {
        texto = "Información No Disponible.";
      }
      return texto;
    },
  },
};
</script>

<style>
.margen-inferior {
  margin-bottom: 1px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/fichaInstitucion/DetallesInstitucion.vue